<!--
 * @Date: 2020-08-05 21:22:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-07 16:02:58
 * @Description: In User Settings Edit
 * @Author: Mosuzi
-->
<template>
  <div class="third-account">
    <div class="account-wx">
      <div class="logo-container">
        <x-svg-icon name="weixin-icon"></x-svg-icon>
      </div>
      <div class="main-title">
        <div class="third-name">
          {{ $t('profile.thirdAccount.wechat') }}
        </div>
        <div class="account-name text-overflow">
          {{ wxUserInfo.account || '未绑定' }}
        </div>
      </div>
      <cube-button v-if="wxUserInfo.isBind" class="link-btn" @click="doUntie">
        {{ $t('profile.thirdAccount.unbindAccount') }}
      </cube-button>
    </div>
  </div>
</template>

<script>
import apis from '@/api'

export default {
  data() {
    return {
      wxUserInfo: {},
      timer: 300
    }
  },
  created() {
    // const request = { ...apis.ACCOUNT.GET_WX_USER_INFO }
    // this.$request(request)
    //   .asyncThen((resp) => {
    //     this.wxUserInfo = resp.data || {}
    //   }, (err) => {
    //     console.error(err)
    //   }).asyncErrorCatch((err) => {
    //     console.error(err)
    //   })
    this.queryUserBind()
  },
  methods: {
    queryUserBind() {
      const request = { ...apis.ACCOUNT.QUERY_ACCOUNT_BIND }
      this.$request(request)
        .asyncThen(resp => {
          if (resp.code === 'ok') {
            if (resp.data && resp.data.length > 0) {
              this.wxUserInfo = resp.data[0]
            }
          }
        }, error => {
          console.error(error)
        })
        .asyncErrorCatch(error => {
          console.error(error)
        })
    },
    doUntie() {
      const request = { ...apis.ACCOUNT.UNBIND_THIRD_PLATFORM }
      request.params = {
        thirdPlatform: 'WECHAT'
      }
      this.timestamp = new Date().getTime()
      const toast = this.$createToast({
        time: 0,
        txt: '解绑中...',
        mask: true
      })
      toast.show()
      this.$request(request)
        .asyncThen((resp) => {
          this.wxUserInfo = {}
          const endTimestamp = new Date().getTime()
          const temp = endTimestamp - this.timestamp
          if (temp >= this.timer) {
            toast.hide()
          } else {
            const timeout = setTimeout(() => {
              toast.hide()
              clearTimeout(timeout)
            }, this.timer - temp)
          }
        }, (err) => {
          console.error(err)
        }).asyncErrorCatch((err) => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss">
.third-account {
  height: 100%;
  background: $--app-body-bgColor;
  .account-wx {
    width: 100%;
    height: 5.143rem;
    display: flex;
    background: $--app-light-color;
    align-items: center;
    .logo-container {
      height: 2.857rem;
        width: 2.857rem;
      padding: 1.143rem;
      .x-svg-icon {
        height: 2.857rem;
        width: 2.857rem;
      }
    }
    .main-title {
      flex: 1;
      .account-name {
        font-size: .857rem;
        margin-top: .571rem;
        color: $--app-notice-color;
      }
    }
    .link-btn {
      margin-right: 1.143rem;
      width: 4.57rem;
      height: 2.2857rem;
      background: $--app-light-color;
      color: $--app-primary-color;
      border: 1px solid $--app-primary-color;
    }
  }
}
</style>

<style lang="scss">
.third-account {
  .account-wx {
    .logo-container {
      .x-svg-icon {
        .svg-icon {
          width: 100% !important;
          height: 100% !important;
        }
      }
    }
  }
}
</style>
